export default __webpack_public_path__ + "97f87a36809901078ceb127739d6b548.svg";